import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  getSystemSettings,
  customStyle
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { ToastError } from "../../../../functions/ToastShow";

//3rd party packages
import { Helmet } from "react-helmet";
import Moment from "react-moment";
import moment from 'moment';
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const DiscountReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let { loading, setLoading, dataPaginating, setDataPaginating, generalSettings } = useContext(SettingsContext);
  const { partyForSearch } = useContext(UserContext);
  let { branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [siteName, setSiteName] = useState("");
  const [option, setOption] = useState("excel");

  const [selectedParty, setSelectedParty] = useState(null);
  const [reportType, setReportType] = useState({value: "discount_report", label: "Discount Report"});
  const [discountActivityReportData, setDiscountActivityReportData] = useState(null);
  const [careOfDiscountReportData, setCareOfDiscountReportData] = useState(null);

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `@page { margin: 10px;}`,
  });

  const handleBranch = (brnch) => {
    setBranch(brnch)
  }


  const handleOption = (e) => {
    setOption(e.target.value)
  }

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {

    setReportData(null);
    setDiscountActivityReportData(null);
    setCareOfDiscountReportData(null);

    if (
      startDate !== null &&
      endDate !== null &&
      branch !== null
    ) {

      setDataPaginating(true);

      var fromDate = moment(startDate).format("YYYY-MM-DD");
      var toDate = moment(endDate).format("YYYY-MM-DD");

      let apiUrl = BASE_URL + "/settings/get-passcode-discount-report";
      let formData = new FormData();

      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", branch?.id);

      if (selectedParty) {
        formData.append("party_name", selectedParty?.name);
      }

      if (reportType?.value === "discount_activity_report") {
        apiUrl = BASE_URL + "/settings/get-all-discount-report";

        axios.post(apiUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("Discount Activity Report Result", res);
          setDiscountActivityReportData(res.data)
          setDataPaginating(false);
          if (option === "excel") {
            componentRef.current.handleDownload();
          } else {
            thermalPrint();
          }
        })
        .catch((error) => {
          setDataPaginating(false);
        });

        return;
      }

      if (reportType?.value === "care_of_discount_report") {
        apiUrl = BASE_URL + "/settings/get-care-of-discount-report";
        let newFormData = new FormData();
        newFormData.append("from_date", fromDate);
        newFormData.append("to_date", toDate);
        newFormData.append("branch_id", branch?.id);
        if (selectedParty) {
          newFormData.append("party_name", selectedParty?.name);
        }

        axios.post(apiUrl, newFormData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("Care Of Discount Report Result", res);
          setCareOfDiscountReportData(res.data)
          setDataPaginating(false);
          if (option === "excel") {
            componentRef.current.handleDownload();
          } else {
            thermalPrint();
          }
        })
        .catch((error) => {
          setDataPaginating(false);
        });

        return;
      }

      axios.post(apiUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("ReportResult", res);
          setReportData(res.data)
          setDataPaginating(false);
          if (option === "excel") {
            componentRef.current.handleDownload();
          } else {
            thermalPrint();
          }
        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      ToastError({title: `${"Please select from date, to date and branch"}`})
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Discount Report"))}</title>
      </Helmet>

      {/* Discount Report Excel Print View*/}
      {reportType?.value === "discount_report" ? (
        <DiscountReportExcelPrintView
          reportData={reportData}
          startDate={startDate}
          endDate={endDate}
          siteName={siteName}
          componentRefThermal={componentRefThermal}
          componentRef={componentRef}
          t={t}
        />
      ) : ""}

      {/* Discount Activity Report Excel Print View*/}
      {reportType?.value === "discount_activity_report" ? (
        <DiscountActivityReportExcelPrintView
          reportData={discountActivityReportData}
          startDate={startDate}
          endDate={endDate}
          siteName={siteName}
          componentRefThermal={componentRefThermal}
          componentRef={componentRef}
          t={t}
        />
      ):""}

      {/* Care Of Discount Report Excel Print View*/}
      {reportType?.value === "care_of_discount_report" ? (
        <CareOfDiscountReportExcelPrintView
          reportData={careOfDiscountReportData}
          startDate={startDate}
          endDate={endDate}
          siteName={siteName}
          componentRefThermal={componentRefThermal}
          componentRef={componentRef}
          t={t}
        />
      ):""}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0" >
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Discount Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end p-0">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={branchForSearch ?? []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>
                        <div className="col-2">
                          <Select
                            options={partyForSearch && partyForSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={selectedParty}
                            isClearable
                            className="table-text"
                            maxMenuHeight="200px"
                            classNamePrefix="select"
                            onChange={(val) => setSelectedParty(val)}
                            placeholder={_t(t("Select a party")) + ".."}
                          />
                        </div>

                        <div className="col-2">

                          <Select
                            options={[
                              {value: "discount_report", label: "Discount Report"},
                              {value: "discount_activity_report", label: "Discount Activity Report"},
                              {value: "care_of_discount_report", label: "Care Of Discount Report"}
                            ]}
                            value={reportType}
                            onChange={(val) => setReportType(val)}
                            isClearable
                            className="table-text"
                            maxMenuHeight="200px"
                            classNamePrefix="select"
                          />
                        </div>


                        <div className="col-2 t-mb-15 mb-md-0 d-none d-md-block text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseSelected()}
                          >
                            DISCOUNT REPORT
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>

    </>
  );
}

export default DiscountReport


const CareOfDiscountReportExcelPrintView = ({ reportData, startDate, endDate, siteName, t, componentRefThermal, componentRef }) => {
  return (
    <>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="care-of-discount-table"
        filename="Care Of Discount Report"
        sheet="sheet 1"
        buttonText="Detail"
        ref={componentRef}
      />

      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12" ref={componentRefThermal}>
                  {reportData !== null && reportData !== undefined && (
                    <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                      <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                        <table
                          className="table table-bordered table-hover min-table-height mt-3"
                          id="care-of-discount-table"
                        >
                          <div className="page-break"></div>
                          <thead className="align-middle">
                            <tr style={{ border: "0px" }}>
                              <th colSpan="13" style={{ border: "0px" }}>
                                <div className="row">
                                  <div className="col-12">
                                    <h3 className="text-center mb-0">{siteName}</h3>
                                    <h3 className="text-center mt-0">Care Of Discount Report</h3>
                                    <p className="text-center">
                                      FROM&nbsp;
                                      <Moment format="LL">{startDate}</Moment>
                                      &nbsp;TO&nbsp;
                                      <Moment format="LL">{endDate}</Moment>
                                    </p>
                                  </div>
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">S#</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Sale Type</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Dining Session</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Inv. #</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Inv. Date</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Client</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Inv. Gross Amt.</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Care of Dis. Amt.(%)</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Round of Dis. Amt.</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Net Amount</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Care Of Referral</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Remarks</th>
                              <th scope="col" className="text-capitalize align-middle text-center border-1 border">Discount By</th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {Object.keys(reportData).length > 0 && Object.keys(reportData).map((branch_name, index) => {
                              let total_gross = 0;
                              let total_discount = 0;
                              let total_net = 0;

                              return (
                                <React.Fragment key={index}>
                                  {reportData[branch_name]?.length > 0 && reportData[branch_name].map((item, i) => {
                                    total_gross += parseFloat(item.gross_amount || 0);
                                    total_discount += parseFloat(item.discount_amount || 0);
                                    total_net += parseFloat(item.net_amount || 0);
                                    
                                    return (
                                      <tr key={i}>
                                        <td className="text-center">{i + 1}</td>
                                        <td className="text-center">{item?.sale_type}</td>
                                        <td className="text-center">{item?.dinning_session}</td>
                                        <td className="text-center">{item?.invoice_no}</td>
                                        <td className="text-center">{item?.invoice_date}</td>
                                        <td className="text-center">{item?.client_name}</td>
                                        <td className="text-center">{item?.gross_amount}</td>
                                        <td className="text-center">{item?.discount_amount} ({item?.discount_percentage}%)</td>
                                        <td className="text-center">{item?.round_off_discount_amount}</td>
                                        <td className="text-center">{item?.net_amount}</td>
                                        <td className="text-center">{item?.care_of_referral}</td>
                                        <td className="text-center">{item?.remarks}</td>
                                        <td className="text-center">{item?.discount_by}</td>
                                      </tr>
                                    );
                                  })}
                                  <tr>
                                    <th colSpan="6" className="text-right">Total</th>
                                    <th className="text-center">{formatPrice(total_gross)}</th>
                                    <th className="text-center">{formatPrice(total_discount)}</th>
                                    <th></th>
                                    <th className="text-center">{formatPrice(total_net)}</th>
                                    <th colSpan="3"></th>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                          <tfoot style={{ border: "0px" }}>
                            <tr style={{ border: "0px" }}>
                              <td colSpan="13" className="text-center" style={{ border: "0px" }}>
                                <h5 className="mt-3">Powered by indolj.pk</h5>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const DiscountReportExcelPrintView = ({ reportData, startDate, endDate, siteName, t,componentRefThermal,componentRef }) => {

  return (
    <>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Discount Report"
        sheet="sheet 1"
        buttonText="Discount Detail"
        ref={componentRef}
      />

      {/* print */}
      <div className="d-none">
        <div ref={componentRefThermal}>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      {siteName}
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      FROM&nbsp;
                      <Moment format="LL">
                        {startDate}
                      </Moment>
                      &nbsp;TO&nbsp;
                      <Moment format="LL">{endDate}</Moment>
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      Print Time:{" "}
                      <Moment format="LLL">
                        {new Date()}
                      </Moment>
                    </span>
                  </div>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    Discount Report
                  </span>
                  {/*catg wise report */}
                  <div className="col-12">
                    {
                      reportData &&
                      reportData !== null && (
                        <div>
                          <p className="mx-1 xsm-text table-text_pos text-capitalize border border-dark py-1 d-flex justify-content-between">
                            <span className="font-weight-bold pl-1" style={{ width: "20.5%" }}>
                              {"Token"}
                            </span>
                            <span className="font-weight-bold" style={{ width: "19%" }}>
                              {"Branch"}
                            </span>

                            <span className="font-weight-bold" style={{ width: "20%" }}>
                              {"Scheme"}
                            </span>

                            <span className="font-weight-bold" style={{ width: "22.5%" }}>
                              {
                                "Discount"}
                            </span>

                            <span className="font-weight-bold pr-1" style={{ width: "18%", textAlign: "right" }}>
                              {
                                "Amount"}
                            </span>
                          </p>
                        </div>
                      )}
                    {
                      reportData &&
                      reportData !== null &&
                      Object.keys(reportData)?.map((group) => {
                        let menuGrpdiscount = 0;
                        let menuGroupPrice = 0;
                        return (
                          <div>
                            <div className="w-100 col-12">
                              <span className="mx-2 d-flex font-weight-bold fk-print-text_pos justify-content-center text-decoration-underline table-text">{group}</span>
                            </div>
                            {
                              reportData[group]?.map((item) => {
                                menuGrpdiscount += parseFloat(item.discount_amount)
                                menuGroupPrice += parseFloat(item.sub_total);
                                return (
                                  <div className="text-capitalize w-100 d-flex justify-content-between py-1">
                                    <span className="mx-1 sm-text font-weight-bold" style={{ width: "20.2%" }}>{item?.token_no}</span>
                                    <span className="mx-1 sm-text font-weight-bold" style={{ width: "20%" }}>{item?.branch_name}</span>
                                    <span className="mx-1 sm-text font-weight-bold" style={{ width: "17%" }}>{item.scheme_name}</span>
                                    <span className="mx-1 sm-text font-weight-bold" style={{ width: "24%" }}>{parseFloat(item.discount_amount)?.toFixed(2)}</span>
                                    <span className="mx-1 sm-text font-weight-bold" style={{ width: "18%", textAlign: "right" }}>{parseFloat(item.total_payable)?.toFixed(2)}</span>
                                  </div>
                                )
                              })
                            }
                            <div className="mb-1 xsm-text fk-print-text_pos fk-print-text--bold text-capitalize d-flex justify-content-between border border-dark">
                              <span style={{ width: "58.5%" }}>Total</span>
                              <span style={{ width: "23%" }}>{menuGrpdiscount?.toFixed(2)}</span>
                              <span className="float-right" style={{ width: "18%", textAlign: "right" }}>{menuGroupPrice?.toFixed(2)}</span>
                            </div>
                          </div>
                        )
                      })
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Excel */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colSpan="17" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Discount Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Manager Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Customer Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Party Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Discount Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Sub Total"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Discount Amt"))}
                                  </th>

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Discount %"))}
                                  </th>

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Tax"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Service Charges"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Delivery Charges"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Total"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("User Name"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {
                                  Object.keys(reportData).length > 0 && Object.keys(reportData).map(
                                    (group_name, index) => {

                                      let totalCalculated = {
                                        discount: 0,
                                        sub_total: 0,
                                        totalAmount: 0,
                                        tax: 0,
                                        service_charges: 0,
                                        delivery_charges: 0,
                                      }

                                      return (
                                        <React.Fragment key={index}>
                                          <tr>
                                            <th
                                              scope="row"
                                              className="lg-text text-capitalize align-middle text-center"
                                            >
                                              {group_name}
                                            </th>
                                          </tr>
                                          {reportData[group_name]?.length > 0 && reportData[group_name].map((item, i) => {
                                            // discount += parseFloat(item.discount_amount)
                                            // totalAmount += parseFloat(item.sub_total);

                                            totalCalculated.discount += parseFloat(item.discount_amount)
                                            totalCalculated.sub_total += parseFloat(item.sub_total);
                                            totalCalculated.totalAmount += parseFloat(item.total_payable);
                                            totalCalculated.tax += parseFloat(item.vat);
                                            totalCalculated.service_charges += parseFloat(item.service_amount);
                                            totalCalculated.delivery_charges += parseFloat(item.service_charge);
                                            return (
                                              <tr key={i}>
                                                <td></td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center "
                                                >
                                                  {i + 1}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.token_no}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.order_date}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.customer_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.branch_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.order_type}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.party_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.scheme_name}
                                                </td>

                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.sub_total}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item.discount_amount}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item.discount}%
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item.vat}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.service_amount}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item?.service_charge}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item.total_payable}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {item.user_name}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                          <tr></tr>
                                          <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              Total
                                            </th>
                                            <td>{formatPrice(totalCalculated?.sub_total)}</td>
                                            <td>{formatPrice(totalCalculated?.discount)}</td>
                                            <td></td>
                                            <td>{formatPrice(totalCalculated?.tax)}</td>
                                            <td>{formatPrice(totalCalculated?.service_charges)}</td>
                                            <td>{formatPrice(totalCalculated?.delivery_charges)}</td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              <strong>
                                                {formatPrice(totalCalculated?.totalAmount)}
                                              </strong>
                                            </td>
                                            <td></td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    }
                                  )
                                }
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colSpan="16"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const DiscountActivityReportExcelPrintView = ({ reportData, startDate, endDate, siteName, t,componentRefThermal,componentRef }) => {

  const asNumber = (v) => {
    const n = typeof v === "number" ? v : parseFloat(v ?? 0);
    return Number.isFinite(n) ? n : 0;
  };

  const fmt = (v) => formatPrice(asNumber(v));
  const fmtPct = (v) => `${asNumber(v).toFixed(2)}%`;

  const isArrayShape = Array.isArray(reportData);
  const discountTypeSummary = isArrayShape ? (Array.isArray(reportData?.[0]) ? reportData[0] : []) : [];
  const partyTypeSummary = isArrayShape ? (Array.isArray(reportData?.[1]) ? reportData[1] : []) : [];
  const partySchemeDetail = isArrayShape && reportData?.[2] && typeof reportData[2] === "object" ? reportData[2] : {};

  return (
    <>
    
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Discount Activity Report"
        sheet="sheet 1"
        buttonText="Discount Activity Detail"
        ref={componentRef}
      />

     {/* print */}
     <div className="d-none">
        <div ref={componentRefThermal}>
          <div className="fk-print w-100">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      {siteName}
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      FROM&nbsp;
                      <Moment format="LL">
                        {startDate}
                      </Moment>
                      &nbsp;TO&nbsp;
                      <Moment format="LL">{endDate}</Moment>
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      Print Time:{" "}
                      <Moment format="LLL">
                        {new Date()}
                      </Moment>
                    </span>
                  </div>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    Discount Report
                  </span>
                  {/*catg wise report */}
                  <div className="col-12">
                    {isArrayShape ? (
                      <div className="mx-1">
                        {/* DISCOUNT TYPE */}
                        <div className="mt-2 border border-dark">
                          <div className="text-center font-weight-bold xsm-text py-1 border-bottom border-dark table-text_pos">
                            DISCOUNT TYPE
                          </div>
                          <div className="d-flex justify-content-between xsm-text font-weight-bold border-bottom border-dark table-text_pos">
                            <span className="py-1 pl-1" style={{ width: "22%" }}>Discount Type</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>Total Sale</span>
                            <span className="py-1 text-center" style={{ width: "18%" }}>Disc. Applied On (#)</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>Discount</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>As per T.Amt.%</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>As per App. Amt.%</span>
                            <span className="py-1 pr-1 text-right" style={{ width: "12%" }}>Net Sale</span>
                          </div>
                          {discountTypeSummary?.map((r, idx) => (
                            <div key={idx} className="d-flex justify-content-between xsm-text border-bottom border-dark table-text_pos">
                              <span className="py-1 pl-1" style={{ width: "22%" }}>{r?.discount_type ?? ""}</span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmt(r?.total_sale)}</span>
                              <span className="py-1 text-center" style={{ width: "18%" }}>
                                ({asNumber(r?.discount_applied_count)}) {fmt(r?.discount_applied_total_sale)}
                              </span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmt(r?.total_discount)}</span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmtPct(r?.discount_on_total_sale_percent)}</span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmtPct(r?.discount_on_discounted_sale_percent)}</span>
                              <span className="py-1 pr-1 text-right" style={{ width: "12%" }}>{fmt(r?.net_sale)}</span>
                            </div>
                          ))}
                        </div>

                        {/* DISCOUNT SUMMARY (PARTY TYPE) */}
                        <div className="mt-2 border border-dark">
                          <div className="text-center font-weight-bold xsm-text py-1 border-bottom border-dark table-text_pos">
                            DISCOUNT SUMMARY ( PARTY TYPE )
                          </div>
                          <div className="d-flex justify-content-between xsm-text font-weight-bold border-bottom border-dark table-text_pos">
                            <span className="py-1 pl-1" style={{ width: "18%" }}>Party Type</span>
                            <span className="py-1 text-center" style={{ width: "10%" }}># of INVs</span>
                            <span className="py-1 text-center" style={{ width: "14%" }}>Total</span>
                            <span className="py-1 text-center" style={{ width: "18%" }}>Disc. Applied On (#)</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>Discount</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>As per T.Amt.%</span>
                            <span className="py-1 text-center" style={{ width: "12%" }}>As per App. Amt.%</span>
                            <span className="py-1 pr-1 text-right" style={{ width: "14%" }}>Net Sale</span>
                          </div>
                          {partyTypeSummary?.map((r, idx) => (
                            <div key={idx} className="d-flex justify-content-between xsm-text border-bottom border-dark table-text_pos">
                              <span className="py-1 pl-1" style={{ width: "18%" }}>{r?.party_type ?? ""}</span>
                              <span className="py-1 text-center" style={{ width: "10%" }}>{asNumber(r?.discount_applied_count)}</span>
                              <span className="py-1 text-center" style={{ width: "14%" }}>{fmt(r?.party_total)}</span>
                              <span className="py-1 text-center" style={{ width: "18%" }}>
                                ({asNumber(r?.discount_applied_count)}) {fmt(r?.discount_applied_total_sale)}
                              </span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmt(r?.total_discount)}</span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmtPct(r?.discount_on_total_sale_percent)}</span>
                              <span className="py-1 text-center" style={{ width: "12%" }}>{fmtPct(r?.discount_on_discounted_sale_percent)}</span>
                              <span className="py-1 pr-1 text-right" style={{ width: "14%" }}>{fmt(r?.net_party_sale)}</span>
                            </div>
                          ))}
                        </div>

                        {/* PARTY -> SCHEME DETAIL */}
                        <div className="mt-2 border border-dark">
                          <div className="text-center font-weight-bold xsm-text py-1 border-bottom border-dark table-text_pos">
                            CARE OF DISCOUNT DETAIL
                          </div>
                          {Object.keys(partySchemeDetail || {})?.length === 0 ? (
                            <div className="xsm-text py-2 text-center table-text_pos">No detail found</div>
                          ) : (
                            Object.keys(partySchemeDetail || {}).map((partyName, idx) => (
                              <div key={idx} className="border-top border-dark">
                                <div className="text-center font-weight-bold xsm-text py-1 border-bottom border-dark table-text_pos">
                                  {partyName}
                                </div>
                                <div className="d-flex justify-content-between xsm-text font-weight-bold border-bottom border-dark table-text_pos">
                                  <span className="py-1 pl-1" style={{ width: "40%" }}>Scheme</span>
                                  <span className="py-1 text-center" style={{ width: "20%" }}>Disc. Applied On (#)</span>
                                  <span className="py-1 text-center" style={{ width: "20%" }}>Discount</span>
                                  <span className="py-1 pr-1 text-right" style={{ width: "20%" }}>Net Sale</span>
                                </div>
                                {(partySchemeDetail?.[partyName] || [])?.map((row, i) => (
                                  <div key={i} className="d-flex justify-content-between xsm-text border-bottom border-dark table-text_pos">
                                    <span className="py-1 pl-1" style={{ width: "40%" }}>{row?.scheme_name ?? ""}</span>
                                    <span className="py-1 text-center" style={{ width: "20%" }}>
                                      ({asNumber(row?.discount_applied_count)}) {fmt(row?.discount_applied_total_sale)}
                                    </span>
                                    <span className="py-1 text-center" style={{ width: "20%" }}>{fmt(row?.total_discount)}</span>
                                    <span className="py-1 pr-1 text-right" style={{ width: "20%" }}>{fmt(row?.net_sale)}</span>
                                  </div>
                                ))}
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        {/* Backward compatible: old shape (object grouped list) */}
                        {reportData && reportData !== null && (
                          <div>
                            <p className="mx-1 xsm-text table-text_pos text-capitalize border border-dark py-1 d-flex justify-content-between">
                              <span className="font-weight-bold pl-1" style={{ width: "20.5%" }}>
                                {"Token"}
                              </span>
                              <span className="font-weight-bold" style={{ width: "19%" }}>
                                {"Branch"}
                              </span>

                              <span className="font-weight-bold" style={{ width: "20%" }}>
                                {"Scheme"}
                              </span>

                              <span className="font-weight-bold" style={{ width: "22.5%" }}>
                                {"Discount"}
                              </span>

                              <span className="font-weight-bold pr-1" style={{ width: "18%", textAlign: "right" }}>
                                {"Amount"}
                              </span>
                            </p>
                          </div>
                        )}
                        {reportData &&
                          reportData !== null &&
                          Object.keys(reportData)?.map((group) => {
                            let menuGrpdiscount = 0;
                            let menuGroupPrice = 0;
                            return (
                              <div key={group}>
                                <div className="w-100 col-12">
                                  <span className="mx-2 d-flex font-weight-bold fk-print-text_pos justify-content-center text-decoration-underline table-text">
                                    {group}
                                  </span>
                                </div>
                                {reportData[group]?.map((item, i) => {
                                  menuGrpdiscount += parseFloat(item.discount_amount);
                                  menuGroupPrice += parseFloat(item.sub_total);
                                  return (
                                    <div key={i} className="text-capitalize w-100 d-flex justify-content-between py-1">
                                      <span className="mx-1 sm-text font-weight-bold" style={{ width: "20.2%" }}>
                                        {item?.token_no}
                                      </span>
                                      <span className="mx-1 sm-text font-weight-bold" style={{ width: "20%" }}>
                                        {item?.branch_name}
                                      </span>
                                      <span className="mx-1 sm-text font-weight-bold" style={{ width: "17%" }}>
                                        {item.scheme_name}
                                      </span>
                                      <span className="mx-1 sm-text font-weight-bold" style={{ width: "24%" }}>
                                        {parseFloat(item.discount_amount)?.toFixed(2)}
                                      </span>
                                      <span className="mx-1 sm-text font-weight-bold" style={{ width: "18%", textAlign: "right" }}>
                                        {parseFloat(item.total_payable)?.toFixed(2)}
                                      </span>
                                    </div>
                                  );
                                })}
                                <div className="mb-1 xsm-text fk-print-text_pos fk-print-text--bold text-capitalize d-flex justify-content-between border border-dark">
                                  <span style={{ width: "58.5%" }}>Total</span>
                                  <span style={{ width: "23%" }}>{menuGrpdiscount?.toFixed(2)}</span>
                                  <span className="float-right" style={{ width: "18%", textAlign: "right" }}>
                                    {menuGroupPrice?.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                      </>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Excel */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colSpan="10" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Discount Activity Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {isArrayShape ? (
                                  <>
                                    <tr>
                                      <th colSpan="10" className="text-center">DISCOUNT TYPE</th>
                                    </tr>
                                    <tr>
                                      <th>Discount Type</th>
                                      <th>Total Sale</th>
                                      <th colSpan="3">Disc. Applied On (#)</th>
                                      <th>Discount</th>
                                      <th>As per T.Amt.%</th>
                                      <th>As per App. Amt.%</th>
                                      <th>Net Sale</th>
                                    </tr>
                                  {discountTypeSummary?.map((r, idx) => (
                                    <tr key={`dts-${idx}`}>
                                      <td align="right">{r?.discount_type ?? ""}</td>
                                      <td align="right">{fmt(r?.total_sale)}</td>

                                      <td align="right" colSpan="3">
                                        ({asNumber(r?.discount_applied_count)}) {fmt(r?.discount_applied_total_sale)}
                                      </td>

                                      <td align="right">{fmt(r?.total_discount)}</td>
                                      <td align="right">{fmtPct(r?.discount_on_total_sale_percent)}</td>
                                      <td align="right">{fmtPct(r?.discount_on_discounted_sale_percent)}</td>
                                      <td align="right">{fmt(r?.net_sale)}</td>
                                    </tr>
                                  ))}


                                    <tr><td colSpan="10"></td></tr>
                                    <tr><td colSpan="10"></td></tr>
                                    <tr><td colSpan="10"></td></tr>

                                    <tr>
                                      <th colSpan="10" className="text-center">DISCOUNT SUMMARY ( PARTY TYPE )</th>
                                    </tr>
                                    <tr>
                                      <th>Party Type</th>
                                      <th># of INVs</th>
                                      <th>Total</th>
                                      <th colSpan="3">Disc. Applied On (#)</th>
                                      <th>Discount</th>
                                      <th>As per T.Amt.%</th>
                                      <th>As per App. Amt.%</th>
                                      <th>Net Sale</th>
                                    </tr>
                                  {partyTypeSummary?.map((r, idx) => (
                                    <tr key={`pts-${idx}`}>
                                      <td align="right">{r?.party_type ?? ""}</td>
                                      <td align="right">{asNumber(r?.discount_applied_count)}</td>
                                      <td align="right">{fmt(r?.party_total)}</td>

                                      <td align="right" colSpan="3">
                                        ({asNumber(r?.discount_applied_count)}) {fmt(r?.discount_applied_total_sale)}
                                      </td>

                                      <td align="right">{fmt(r?.total_discount)}</td>
                                      <td align="right">{fmtPct(r?.discount_on_total_sale_percent)}</td>
                                      <td align="right">{fmtPct(r?.discount_on_discounted_sale_percent)}</td>
                                      <td align="right">{fmt(r?.net_party_sale)}</td>
                                    </tr>
                                  ))}

                                    <tr><td colSpan="10"></td></tr>
                                    <tr><td colSpan="10"></td></tr>
                                    <tr><td colSpan="10"></td></tr>
                                    <tr>
                                      <th colSpan="8" className="text-center">CARE OF DISCOUNT DETAIL</th>
                                    </tr>
                                    <tr><td colSpan="8"></td></tr>

                                    {Object.keys(partySchemeDetail || {})?.map((partyName, idx) => (
                                      <React.Fragment key={`psd-${idx}`}>
                                        <tr>
                                          <th colSpan="8">{partyName}</th>
                                          <th colSpan="8"></th>
                                        </tr>
                                        <tr>
                                          <th>Scheme</th>
                                          <th colSpan="3">Disc. Applied On (#)</th>
                                          <th>Discount</th>
                                          <th>Net Sale</th>
                                        </tr>
                                        {(partySchemeDetail?.[partyName] || [])?.map((row, i) => (
                                          <tr key={`psd-${idx}-${i}`}>
                                            <td align="right">{row?.scheme_name ?? ""}</td>

                                            <td align="right" colSpan="3">
                                              ({asNumber(row?.discount_applied_count)}) {fmt(row?.discount_applied_total_sale)}
                                            </td>

                                            <td align="right">{fmt(row?.total_discount)}</td>
                                            <td align="right">{fmt(row?.net_sale)}</td>
                                          </tr>
                                        ))}
                                        <tr><td colSpan="8"></td></tr>
                                      </React.Fragment>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {/* Backward compatible: old shape (object grouped list) */}
                                    {Object.keys(reportData).length > 0 && Object.keys(reportData).map(
                                      (group_name, index) => {

                                        let totalCalculated = {
                                          discount: 0,
                                          sub_total: 0,
                                          totalAmount: 0,
                                          tax: 0,
                                          service_charges: 0,
                                          delivery_charges: 0,
                                        }

                                        return (
                                          <React.Fragment key={index}>
                                            <tr>
                                              <th
                                                scope="row"
                                                className="lg-text text-capitalize align-middle text-center"
                                              >
                                                {group_name}
                                              </th>
                                            </tr>
                                            {reportData[group_name]?.length > 0 && reportData[group_name].map((item, i) => {
                                              totalCalculated.discount += parseFloat(item.discount_amount)
                                              totalCalculated.sub_total += parseFloat(item.sub_total);
                                              totalCalculated.totalAmount += parseFloat(item.total_payable);
                                              totalCalculated.tax += parseFloat(item.vat);
                                              totalCalculated.service_charges += parseFloat(item.service_amount);
                                              totalCalculated.delivery_charges += parseFloat(item.service_charge);
                                              return (
                                                <tr key={i}>
                                                  <td></td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center "
                                                  >
                                                    {i + 1}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.token_no}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.order_date}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.customer_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.branch_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.order_type}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.party_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.scheme_name}
                                                  </td>

                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.sub_total}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.discount_amount}{" "} ({item.discount}%)
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.vat}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.service_amount}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item?.service_charge}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.total_payable}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.user_name}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                            <tr></tr>
                                            <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                Total
                                              </th>
                                              <td>{formatPrice(totalCalculated?.sub_total)}</td>
                                              <td>{formatPrice(totalCalculated?.discount)}</td>
                                              <td>{formatPrice(totalCalculated?.tax)}</td>
                                              <td>{formatPrice(totalCalculated?.service_charges)}</td>
                                              <td>{formatPrice(totalCalculated?.delivery_charges)}</td>
                                              <td
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                <strong>
                                                  {formatPrice(totalCalculated?.totalAmount)}
                                                </strong>
                                              </td>
                                              <td></td>
                                            </tr>
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                  </>
                                )}
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colSpan="16"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}